import React, {FC, useState} from "react";
import {Button} from "react-bootstrap";
import DropdownRole, {DropdownRoles, Role} from "./DropwdownRole";
import DropdownEmployees, {DropdownEmployeesValues} from "./DropwdownEmployees";
import {UserInfoProps} from "../AuthenticatedApp";

export interface UserInfoCompProps {
  show: boolean
  signIn: () => void
  setUserInfo: (p: UserInfoProps) => void
}

const UserInfo: FC<UserInfoCompProps> = ({show, signIn, setUserInfo}) => {
  const [role, setRole] = useState<Role>(DropdownRoles[0]);
  const [employees, setEmployees] = useState<Role>(DropdownEmployeesValues[0]);
  const [error, setError] = useState<any>(null);
  if (!show) {
    return null;
  }

  function next() {
    if (role.value === "") {
      setError({message: "Please select your role"}); // todo
    } else if (employees.value === "") { // also todo: remember these orange values when switch between sign in and sign up - or just reset the dropdowns
      setError({message: "Please select number of employees or collaborators in your company"});
    } else {
      setError(null);
      setUserInfo({role: role.value, employees: employees.value, gamerReason: ""});
    }
  }

  const errorMessage = error ?
    <div className="row error">
      <div className="col-3 d-none d-md-block">&nbsp;</div>
      <div className="col-12 col-md-6 pb-2">
        {error.message}
      </div>
      <div className="col-3 d-none d-md-block">&nbsp;</div>
    </div>
    : null;

  return (
    <section className='container user-info p-4'>
      {errorMessage}
      <DropdownRole role={role} setRole={setRole}/>
      <DropdownEmployees employee={employees} setEmployees={setEmployees}/>
      <div className="row pt-4">
        <div className="col-3 d-none d-md-block">&nbsp;</div>
        <div className="col-12 col-md-6 pt-2">
          Villa works on Meta Quest 2 and above<br/>
          (Quest 1 is no longer supported by Meta)
        </div>
      </div>
      <div className="row pt-4">
        <div className="col-3 d-none d-md-block">&nbsp;</div>
        <div className="col-12 col-md-6 pt-2">
          <Button
            onClick={next}
            variant="primary">
            Next
          </Button>
        </div>
        <div className="col-3 d-none d-md-block">&nbsp;</div>
      </div>
      <div className="row px-0 pt-4">
        <div className="col-3 d-none d-md-block">&nbsp;</div>
        <div className="col-12 col-md-6 pt-2 px-0">
          <div className="col">
            Existing account? <a href="/#"
                                 data-test="sign-up-sign-in-link"
                                 className="orange" onClick={signIn}>SIGN IN</a>
          </div>
        </div>
        <div className="col-3 d-none d-md-block">&nbsp;</div>
      </div>
    </section>
  );
}

export default UserInfo;
